// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { requestPasswordReset } from 'actions/me'

// Atoms
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import TextInput from 'atoms/TextInput'
import { LinkButton } from 'atoms/Link'
import CenteredCard from 'atoms/CenteredCard'
import FormCard from 'atoms/FormCard'

const mapDispatchToProps = {
  requestPasswordResetAction: requestPasswordReset
}

export default
@connect(null, mapDispatchToProps)
class GuestForgotPasswordPage extends Component {
  static propTypes = {
    defaultEmail: PropTypes.string,
    requestPasswordResetAction: PropTypes.func.isRequired,
  }

  constructor({ defaultEmail }) {
    super()
    this.state = {
      email: defaultEmail || '',
      emailSent: false,
    }
  }

  handleSubmit = async (cancelToken) => {
    const { requestPasswordResetAction } = this.props
    const { email } = this.state
    await requestPasswordResetAction(email, cancelToken)
    this.setState({ emailSent: true })
  }

  handleEmailSave = (email) => {
    this.setState({ email })
  }

  handleSendAgainClick = () => {
    this.setState({ emailSent: false })
  }

  renderForm() {
    const { email } = this.state
    return (
      <FormCard
        component={CenteredCard}
        onSubmit={this.handleSubmit}
        title="Password reset"
        applyButton={<Button>Reset password</Button>}
        cancelButton={<LinkButton to="/login">Cancel</LinkButton>}
      >
        <CardContent>
          <TextInput
            required
            email
            withBorder
            type="email"
            label="Email address"
            placeholder="email@example.com"
            defaultValue={email}
            onSave={this.handleEmailSave}
          />
        </CardContent>
      </FormCard>
    )
  }

  renderEmailSent() {
    return (
      <CenteredCard>
        <CardHeader title="Password reset" />
        <CardContent>
          <Typography>
            We've sent you a link to reset your password
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" color="secondary" onClick={this.handleSendAgainClick}>
            Send again
          </Button>
        </CardActions>
      </CenteredCard>
    )
  }

  render() {
    const { emailSent } = this.state
    return emailSent
      ? this.renderEmailSent()
      : this.renderForm()
  }
}
